// eslint-disable-next-line import/prefer-default-export
export const palette = {
  red: '#f63942',
  orange: '#ff7400',
  accent: '#F3764F',
  yellow: '#FFD700',
  blue: '#5373fc',
  black: '#000035',
  white: '#ffffff',
  newBlue: '#5373FC',
  accept: '#33C879',
  greenMain: '#0f3f44',
  success: '#33C879',
  lightgray: '#797575',
  disabled: '#cbc6c6',
  ultraPale: 'rgb(249, 249, 249)',
  lightBS: 'rgba(0, 0, 0, 0.08) 0px 3px 10px',
  heavyBS: 'rgba(0, 0, 0, 0.63) 0px 0px 43px -13px',
  link: '#1264a3',
  light: " 'pieza-light', sans-serif",
  // reg: " 'pieza-reg', sans-serif",
  med: "'pieza-med', sans-serif",
  bold: "'pieza-bold', sans-serif",
  customColor: '#5373fc',
  reg: ' futura-pt, sans-serif',
};
